import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Drawer,
  Toolbar,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Collapse,
  Icon
} from '@mui/material';

const drawerWidth = 280;

const menuItems = [
  {
    type: 'link',
    text: 'Dashboard',
    icon: 'dashboard',
    path: '/'
  },
  {
    type: 'section',
    text: 'Tools',
    icon: 'build',
    key: 'tools',
    children: [
      { text: 'Tools will be added here', disabled: true }
    ]
  },
  {
    type: 'section',
    text: 'API',
    icon: 'api',
    key: 'api',
    children: [
      { text: 'Auth Token', icon: 'vpn_key', path: '/auth-token' },
      { text: 'Ask PDF', icon: 'psychology', path: '/ask-pdf' },
      { text: 'Download PDFs', icon: 'download', path: '/download-pdfs' },
      { text: 'PDF Status', icon: 'info', path: '/pdf-status' },
      { text: 'List PDFs', icon: 'list', path: '/list-pdfs' },
      { text: 'Health Check', icon: 'health_and_safety', path: '/health-check' }
    ]
  },
  {
    type: 'section',
    text: 'Servers',
    icon: 'dns',
    key: 'servers',
    children: [
      { text: 'Server links will be added here', disabled: true }
    ]
  },
  {
    type: 'section',
    text: 'Demos',
    icon: 'play_arrow',
    key: 'demos',
    children: [
      { text: 'Demo links will be added here', disabled: true }
    ]
  }
];

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [openSections, setOpenSections] = useState({
    tools: false,
    api: true, // Start with API section open
    servers: false,
    demos: false
  });

  const handleSectionToggle = (section) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const handleNavigation = (path) => {
    if (path) {
      navigate(path);
    }
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const renderMenuItem = (item) => {
    if (item.type === 'link') {
      return (
        <ListItemButton
          key={item.text}
          onClick={() => handleNavigation(item.path)}
          selected={isActive(item.path)}
        >
          <ListItemIcon>
            <Icon>{item.icon}</Icon>
          </ListItemIcon>
          <ListItemText primary={item.text} />
        </ListItemButton>
      );
    }

    if (item.type === 'section') {
      return (
        <React.Fragment key={item.key}>
          <ListItemButton onClick={() => handleSectionToggle(item.key)}>
            <ListItemIcon>
              <Icon>{item.icon}</Icon>
            </ListItemIcon>
            <ListItemText primary={item.text} />
            <Icon>
              {openSections[item.key] ? 'expand_less' : 'expand_more'}
            </Icon>
          </ListItemButton>
          <Collapse in={openSections[item.key]} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {item.children.map((child, index) => (
                child.disabled ? (
                  <ListItem key={index} sx={{ pl: 4 }}>
                    <ListItemText 
                      primary={child.text}
                      primaryTypographyProps={{ 
                        fontSize: '0.875rem', 
                        color: 'text.secondary' 
                      }}
                    />
                  </ListItem>
                ) : (
                  <ListItemButton
                    key={child.text}
                    sx={{ pl: 4 }}
                    onClick={() => handleNavigation(child.path)}
                    selected={isActive(child.path)}
                  >
                    {child.icon && (
                      <ListItemIcon sx={{ minWidth: 36 }}>
                        <Icon>{child.icon}</Icon>
                      </ListItemIcon>
                    )}
                    <ListItemText 
                      primary={child.text}
                      primaryTypographyProps={{ fontSize: '0.875rem' }}
                    />
                  </ListItemButton>
                )
              ))}
            </List>
          </Collapse>
        </React.Fragment>
      );
    }

    return null;
  };

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <Toolbar>
        <Typography variant="h6" noWrap component="div" sx={{ fontWeight: 600 }}>
          SE Tools
        </Typography>
      </Toolbar>
      <List>
        {menuItems.map(renderMenuItem)}
      </List>
    </Drawer>
  );
}

export default Sidebar;
